import { LocalStorageService } from './../localStorage/localStorage.service';
import { Injectable } from '@angular/core';
import { Geolocation } from '@capacitor/geolocation';
import { DeviceService } from '../device/device.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { localStorageKeys } from '../localStorage/localStorageVariables';
@Injectable({
  providedIn: 'root',
})
export class LocationService {
  constructor(
    private deviceService: DeviceService,
    private httpClient: HttpClient,
    private localStorageService: LocalStorageService
  ) {}

  public currentAddress: string;
  structuredAddress: any;

  async getCurrentLocation() {
    try {
      return await Geolocation.getCurrentPosition().then(
        async (coordinates) => {
          if (coordinates) {
            let data = {
              latitude: coordinates?.coords?.latitude,
              longitude: coordinates?.coords?.longitude,
              timestamp: coordinates?.timestamp,
            };
            this.localStorageService.setItem(
              localStorageKeys.LAT_LONG_DATA,
              JSON.stringify(data)
            );
            // this.sendLocationCoordinates(data);
            this.getLocationFromLatLong(
              coordinates?.coords?.latitude,
              coordinates?.coords?.longitude
            ).subscribe(
              (data) => {
                if (data.results && data.results.length > 0) {
                  this.structuredAddress = this.generateAddressObject(
                    data?.results
                  );
                  this.localStorageService.setItem(
                    localStorageKeys.ADDRESS,
                    JSON.stringify(this.structuredAddress)
                  );
                }
              },
              (error) => {
                console.error('Error fetching location data', error);
              }
            );
            return true;
          } else {
            return false;
          }
        }
      );
    } catch (Exception) {
      return false;
    }
  }

  requestLocationAccess(): Promise<boolean> {
    return Geolocation.requestPermissions().then(async (response) => {
      if (response.location == 'granted') {
        return await this.getCurrentLocation();
      } else {
        return false;
      }
    }).catch(() => {
      return false;
    });
  }

  checkForLocationAccess(): Promise<boolean> {
    return Geolocation.checkPermissions().then(async (response) => {
      if (response.location == 'granted') {
        return await this.getCurrentLocation();
      } else if (response.location == 'prompt') {
        return await this.requestLocationAccess();
      } else {
        return await this.requestLocationAccess();
      }
    }).catch(() => {
      return false;
    });
  }

  async getLocationPermission() {
    const permission = await Geolocation.checkPermissions();
    if (permission.location === 'granted') {
      // Location permission granted
      // Add your code here
      return true;
    } else if (permission.location === 'prompt') {
      Geolocation.requestPermissions({
        permissions: ['location', 'coarseLocation'],
      });
      // Location permission prompt
      // Add your code here
      return true;
    } else {
      // Location permission denied
      // Add your code here
      // this.uiService.presentToast('Location access denied');
      return false;
    }
  }

  sendLocationCoordinates(coordinates: any) {
    this.deviceService.sendLocationCoordiantes(coordinates).subscribe({
      next: (response) => {},
      error: (err: any) => {},
      complete: () => {},
    });
  }

  getLocationFromLatLong(latitude: number, longitude: number): Observable<any> {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${environment.googlePlacesApiKey}`;
    return this.httpClient.get(url);
  }

  getCurrentAddress() {
    return this.localStorageService.getItem('currentLocation');
  }

  generateAddressObject(data: any): any {
    const closestAddres = data.filter(
      (obj: any) => obj.types && obj.types.includes('street_address')
    ) || [...data[0]];
    const address_components = closestAddres?.[0]?.address_components;
    const output = {
      street: '',
      line2: '',
      landmark: '',
      city_name: '',
      postal_code: '',
      formatted_address: '',
    };
    let premise = '';
    let street_number = '';
    let route = '';
    let sublocality_level_1 = '';
    let sublocality_level_2 = '';
    if (address_components === undefined) return output;
    Object.keys(address_components).forEach((item) => {
      if (address_components[item].types.includes('postal_code')) {
        output.postal_code = address_components[item].long_name;
      }
      if (
        address_components[item].types.includes('administrative_area_level_3')
      ) {
        output.city_name = address_components[item].long_name;
      }
      if (address_components[item].types.includes('establishment')) {
        output.landmark = address_components[item].long_name;
      }
      if (address_components[item].types.includes('route')) {
        route = address_components[item].long_name;
      }
      if (address_components[item].types.includes('street_number')) {
        street_number = address_components[item].long_name;
      }
      if (address_components[item].types.includes('premise')) {
        premise = address_components[item].long_name;
      }
      if (address_components[item].types.includes('sublocality_level_1')) {
        sublocality_level_1 = address_components[item].long_name;
      }
      if (address_components[item].types.includes('sublocality_level_2')) {
        sublocality_level_2 = address_components[item].long_name;
      }
    });
    const objectValues = Object.values(output).join(' ').toLowerCase();
    const addressWords = closestAddres[0].formatted_address.split(',');
    output.formatted_address = closestAddres[0].formatted_address;
    let notInObject = '';
    for (let word of addressWords) {
      word = word.trim();
      if (!objectValues.includes(word.toLowerCase())) {
        notInObject = word;
        break;
      }
    }
    output.street = [notInObject, premise, street_number, route]
      .filter(Boolean)
      .join(', ');
    output.line2 = `${sublocality_level_2}, ${sublocality_level_1}`;

    return output;
  }

  checkIfStaleLocation() {
    const latLongData = JSON.parse(
      this.localStorageService.getItem(localStorageKeys.LAT_LONG_DATA)
    );
    let isStale = false;

    const currentTime = new Date();
    const addressTime = new Date(latLongData?.timestamp);

    const timeDifferenceInMinutes =
      (currentTime.getTime() - addressTime.getTime()) / (1000 * 60);

    if (timeDifferenceInMinutes > 10) {
      isStale = true;
    }
    return isStale;
  }
}
